import React, { useState } from 'react'

import classes from './LoginPage.module.scss'
import LogoWhite from '../LogoWhite'
import GoogleLogo from '../GoogleLogo'
import Button from '../Button'
import TextInput from '../TextInput'
import Accordion from '../Accordion'
import { useLogin } from '../../hooks/useLogin'
import HelperText from '../HelperText'
import { useTranslation, I18nextProvider } from 'react-i18next'
import i18n from '../../services/i18n'
import EmailIcon from '../EmailIcon'
import PasswordIcon from '../PasswordIcon'
import EyeIcon from '../EyeIcon'
import HidePasswordIcon from '../HidePasswordIcon'
import LanguagePicker from '../LanguagePicker/LanguagePicker'
import MasterLogo from '../MasterLogo'

const LoginPage = () => {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = useState(false)

  const {
    handleLoginWithGoogle,
    loginError,
    logingInWithGoogle,
    logingInWithEmailAndPassword,
    handleLoginWithEmailAndPassword,
    handleEmailChange,
    handlePasswordChange,
    email,
    password,
  } = useLogin()

  const isInvalid = email === '' || password === ''

  const handleToggleShowPassword = () => {
    setShowPassword((value) => !value)
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    handleLoginWithEmailAndPassword({ email, password })
  }

  return (
    <div className={classes.root}>
      <LanguagePicker className={classes.languagePicker} />

      <header className={classes.header}>
        <MasterLogo />

        <LanguagePicker className={classes.languagePicker} />
      </header>

      <section className={classes.logoWrapper}>
        <LogoWhite />
      </section>

      <section className={classes.formWrapper}>
        <div className={classes.formContent}>
          <p className={classes.paragraph}>{t('welcome')}</p>
          <h1 className={classes.title}>{t('sign_in')}</h1>

          <Button
            onClick={handleLoginWithGoogle}
            color="secondary"
            startIcon={<GoogleLogo />}
            disabled={logingInWithGoogle}
          >
            {t('sign_in_with_google')}
          </Button>

          {loginError && <HelperText color="error">{t(loginError)}</HelperText>}

          <Accordion className={classes.accordion} title={t('or')}>
            <form onSubmit={handleSubmit} className={classes.form}>
              <TextInput
                label={t('email')}
                name="email"
                type="email"
                className={classes.input}
                onChange={handleEmailChange}
                startIcon={<EmailIcon />}
                required
                autoFocus
              />

              <TextInput
                type={showPassword ? 'text' : 'password'}
                label={t('password')}
                name="password"
                className={classes.input}
                required
                startIcon={<PasswordIcon />}
                endIcon={
                  <button
                    className={classes.showPasswordBtn}
                    type="button"
                    onClick={handleToggleShowPassword}
                  >
                    {showPassword ? <HidePasswordIcon /> : <EyeIcon />}
                  </button>
                }
                onChange={handlePasswordChange}
              />

              <Button
                fullWidth
                color="primary"
                disabled={
                  logingInWithEmailAndPassword ||
                  logingInWithGoogle ||
                  isInvalid
                }
              >
                Login now
              </Button>
            </form>
          </Accordion>
        </div>
      </section>
    </div>
  )
}

type LoginPageProps = {
  // Kept for compatibility matters
  title?: string
}

const LoginPageContainer = (_: LoginPageProps) => {
  return (
    <I18nextProvider i18n={i18n}>
      <LoginPage />
    </I18nextProvider>
  )
}

export default LoginPageContainer
